import React, { useState } from "react";
import { processErrorMessage } from "@quest-finance/quest-fe-shared/dist/error-handler/utils";
import { Button, Popconfirm, message } from "antd";
import { AxiosError } from "axios";
import cs from "classnames";
import {
  showErrorPopUp,
  showSuccessPopUp,
} from "../../../common/components/ShowNotification/showNotification";
import LMSService from "../../services/LMSService";
import { FinpowerXmlOption } from "../../types";

export type SubmitApplicationBtnProps = {
  assessmentId: string;
  onSubmitSucess?: () => void;
  submittedToLms?: boolean;
};

const notifKey = "push-to-lms-notif";

const SubmitApplicationBtn: React.FC<SubmitApplicationBtnProps> = (
  props: SubmitApplicationBtnProps
) => {
  const { submittedToLms } = props;
  const [loading, setLoading] = useState(false);
  const onConfirmHandler = async (xmlOption = FinpowerXmlOption.ACCOUNT) => {
    setLoading(true);
    message.destroy(notifKey);

    try {
      await LMSService.submitToLms({
        assessmentId: props.assessmentId,
        xmlOption,
      });
      props.onSubmitSucess?.();
      showSuccessPopUp("Application successfully sent to LMS");
    } catch (e) {
      const content = processErrorMessage(e as AxiosError);
      showErrorPopUp(content, notifKey);
    } finally {
      setLoading(false);
    }
  };

  const confirmationText = submittedToLms ? (
    <>
      Application has already been pushed to LMS.
      <div>Do you want to re-push?</div>
    </>
  ) : (
    "Submit this application to LMS?"
  );

  return (
    <>
      <Popconfirm
        title={<div data-testid="confirmation-text">{confirmationText}</div>}
        okText="Submit"
        cancelText="Cancel"
        onConfirm={() => onConfirmHandler()}
        arrow={{ pointAtCenter: true }}
      >
        <Button
          className={cs(
            "me-2",
            submittedToLms ? "qf-btn-gray-invert" : "qf-btn-green"
          )}
          loading={loading || submittedToLms === undefined}
          data-testid="push-to-lms"
        >
          Push application to LMS
        </Button>
      </Popconfirm>
    </>
  );
};

export default SubmitApplicationBtn;
